import React, { useState, useEffect } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Table, Space, Dropdown } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { sortBy, find } from "lodash";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import closeIcon from "../../../assets/icons/x-circle.svg";
import Calendar from "../../../assets/icons/calendar.svg";
import Clock from "../../../assets/icons/clock.svg";
import Kebab from "../../../assets/icons/Kebab contacts.svg";
import invoice from "../../../assets/icons/Invoice.svg";
import delete1 from "../../../assets/icons/Group 2723.svg";
import Reload from "../../../assets/icons/Reload.svg";
import plusCircle from "../../../assets/icons/plusCircle.svg";
import { RecurrenceModal } from "./Recurrence";
import {
  maintainaceStatusList,
  changeMaintenanceStatus,
  assignMaintenence,
  deleteMaintenance,
} from "../../../redux/actions/maintenanceAction";
import DeletePopUp from "../../Dailogs/DeletePopUp";
import { FetchActiveUsers } from "../../../redux/actions/action";

import "../../../assets/styles/local/Maintenance.css";
import { WorkMaintenanceModal } from "./WorkMaintenanceModal";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";

export const MaintenanceList = ({ maintenanceList }) => {
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;

  const [menuActive, setMenuActive] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [showplusCircle, setShowplusCircle] = useState(true);
  const [managerShowBox, setManagerShowBox] = useState(false);
  const [showDropPeople, setShowDropPeople] = useState(false);
  const [showImgCircle, setShowImgCircle] = useState(false);
  const [activeUsers, setActiveUsers] = useState([]);
  const [searchPeople, setSearchPeople] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showWorkModal, setShowWorkModal] = useState(false);
  const [fullDocPeopleList2, setFullDocPeopleList2] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [assetMaintainaceId, setAssetMaintenanceId] = useState("");
  const dispatch = useDispatch();
  const statusList = useSelector((state) => state.maintenance.statusList);
  const companyId = window.localStorage.getItem("companyid");

  const activeStatusResponse = useSelector(
    (state) => state.user.activeStatusResponse,
  );

  useEffect(() => {
    dispatch(maintainaceStatusList());
    dispatch(FetchActiveUsers(companyId));
  }, []);
  useEffect(() => {
    if (activeStatusResponse?.status === true) {
      setFullDocPeopleList2(activeStatusResponse?.data);
      setActiveUsers(activeStatusResponse?.data);
    }
  }, [activeStatusResponse]);

  useEffect(() => {
    if (searchPeople) {
      let people = [...fullDocPeopleList2];
      people = people.filter((people) => {
        const fullName = `${people.firstname} ${people.lastname}`;
        return (
          people.firstname
            ?.toLowerCase()
            .startsWith(searchPeople.toLowerCase()) ||
          people.lastname
            ?.toLowerCase()
            .startsWith(searchPeople.toLowerCase()) ||
          fullName.toLowerCase().startsWith(searchPeople.toLowerCase())
        );
      });

      setActiveUsers(people);
    } else {
      setActiveUsers([...fullDocPeopleList2]);
    }
  }, [searchPeople]);

  const items = sortBy(statusList, ["order"]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-Add").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (location?.state?.from === "Header_To_Open_Work_Modal") {
      setShowWorkModal(true);
      setAssetMaintenanceId(location?.state?.data);
      setActiveMenu(location?.state?.data);
      console.log("asc45", location?.state?.data);

      // Clear the history state so it doesn’t re-trigger
      history.replace({
        ...location,
        state: {}, // clear the state
      });
    }
  }, [location?.state?.from]);

  const columns = [
    {
      // title: "Work ID",
      title: t("WORK ID"),
      dataIndex: "workId",
      key: "workId",
      width: "10%",
      render: (_, record) => {
        return (
          <div>
            <span
              className="link-text"
              onClick={() => {
                setAssetMaintenanceId(record.assetMaintainaceId);
                setActiveMenu(record.assetMaintainaceId);
                window.localStorage.setItem(
                  "assetMaintenanceId",
                  record.assetMaintainaceId,
                );

                setShowWorkModal(true);
              }}
            >
              {record.workId}
            </span>
            {showWorkModal && record.assetMaintainaceId === activeMenu ? (
              <WorkMaintenanceModal
                assetMaintainaceId={record.assetMaintainaceId}
                showWorkModal={showWorkModal}
                setShowWorkModal={setShowWorkModal}
                type="update"
              />
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      // title: "Work Name",
      title: t("Work Name"),
      dataIndex: "workName",
      key: "maintainaceName",
      width: "20%",
      // responsive: ["md"],
      render: (workName) => <span>{workName ? workName : " "}</span>,
    },
    {
      title: () => (
        <Space size="middle">
          <img className="calendarIcon pointer" src={Calendar} alt="" />
          {/* Start Date */}
          {t("Start Date")}
        </Space>
      ),
      dataIndex: "startDate",
      key: "startDate",
      width: "15%",
      // responsive: ["md"],
      render: (_, record) => (
        <span
          className={
            moment() > moment(record.startDate) &&
            record.status?.statusName === "Pending"
              ? "warning"
              : ""
          }
        >
          {moment(record.startDate).format("D.MM.YYYY")}
        </span>
      ),
    },
    {
      title: () => (
        <Space size="middle">
          <img className="calendarIcon pointer" src={Clock} alt="" />
          {/* Start Time */}
          {t("Start Time")}
        </Space>
      ),
      dataIndex: "startTime",
      key: "startTime",
      width: "15%",
      render: (_, record) => (
        <span
          className={
            moment() > moment(record.startDate) &&
            record.status?.statusName === "Pending"
              ? "warning"
              : ""
          }
        >
          {record.startTime}
        </span>
      ),
    },
    {
      // title: "Assigned To",
      title: t("Assigned To"),
      dataIndex: "assignedTo",
      key: "assignedTo",
      width: "20%",
      render: (_, record) => (
        <div className="d-flex">
          {/* <div className="projectManagerInput ps-4 d-flex align-items-center"> */}
          {record?.assignedTo?.length > 0 && (
            <>
              {console.log("asc leng2", record?.assignedTo?.length)}
              {record.assignedTo?.slice(0, 3).map((item, index) => {
                return (
                  <div key={index}>
                    {item.imageurl ? (
                      <img
                        src={item?.imageurl}
                        className="orderIcon"
                        style={{
                          width: "35px",
                          height: "35px",
                          cursor: "pointer",
                          borderRadius: "100%",
                          marginLeft: "-25px",
                          border: "0.2vw #ffffff solid ",
                          objectFit: "cover",
                        }}
                        alt=""
                        onClick={() => {
                          setShowDropPeople(!showDropPeople);
                          setSearchPeople("");
                        }}
                      />
                    ) : (
                      <div
                        className="abbre-pop"
                        style={{ width: "35px", height: "35px" }}
                      >
                        {item?.lastname
                          ? item?.firstname[0]?.toUpperCase() +
                            "" +
                            item?.lastname[0]?.toUpperCase()
                          : item?.firstname?.slice(0, 2).toUpperCase()}
                      </div>
                    )}
                  </div>
                );
              })}

              {/* rest of counted assignee 👇 */}
              {record.assignedTo.length > 3 && (
                <div className="px-1 lengthInCircle">
                  +{record.assignedTo.length - 3}
                  <p className="d-none">ASC</p>
                </div>
              )}
            </>
          )}

          {showplusCircle && (
            <img
              src={plusCircle}
              className="pointer"
              alt=""
              style={{ width: "25px" }}
              onClick={(e) => {
                setManagerShowBox(true);
                setShowDropPeople(!showDropPeople);
                setActiveMenu(record.assetMaintainaceId);
              }}
            />
          )}

          {showImgCircle && record.assetMaintainaceId === activeMenu && (
            <>
              {record?.assignTo?.length
                ? record.assignTo.map((item, index) => {
                    return (
                      <div key={index}>
                        {item.imageurl ? (
                          <img
                            src={item?.imageurl}
                            className="orderIcon"
                            style={{
                              width: "clamp(56px, 2.917vw, 2.917vw)",
                              height: "clamp(56px, 2.917vw, 2.917vw)",
                              cursor: "pointer",
                              borderRadius: "100%",
                              marginLeft: "-25px",
                              border: "0.2vw #ffffff solid ",
                              objectFit: "cover",
                            }}
                            alt=""
                            onClick={() => {
                              setShowDropPeople(!showDropPeople);
                              setSearchPeople("");
                            }}
                          />
                        ) : (
                          <div className="abbre-pop">
                            {item?.lastname
                              ? item?.firstname[0]?.toUpperCase() +
                                "" +
                                item?.lastname[0]?.toUpperCase()
                              : item?.firstname?.slice(0, 2).toUpperCase()}
                          </div>
                        )}
                      </div>
                    );
                  })
                : ""}
              <p className="pt-3 managerText ps-2">{record.assignedTo}</p>
            </>
          )}

          {/*////// ASC WITH IMG SELECT BOX START //////*/}

          <div className="gap-2 mt-2 me-2 d-flex">
            {showDropPeople && record.assetMaintainaceId === activeMenu && (
              <div
                className="withImgSelectBox"
                id="ascSelectBox"
                style={{ zIndex: "1" }}
              >
                <div class="d-flex search_Div_People">
                  <input
                    type="text"
                    className="search_People_Input"
                    style={{ width: "90%" }}
                    placeholder="Search"
                    value={searchPeople}
                    onChange={(e) => {
                      setSearchPeople(e.target.value);
                    }}
                  />
                  <img
                    className="pointer"
                    src={closeIcon}
                    alt=""
                    style={{ width: "20px" }}
                    onClick={() => {
                      setShowDropPeople(false);
                      setSearchPeople("");
                    }}
                  />
                </div>

                {[
                  ...(searchPeople.length
                    ? activeUsers?.filter(
                        (item) =>
                          item.firstname
                            ?.toLowerCase()
                            .includes(searchPeople) ||
                          item.lastname?.toLowerCase().includes(searchPeople),
                      )
                    : activeUsers),
                ].map((people, index) => {
                  const isUserAssigned = record?.assignedTo?.some(
                    (x) => x?.userId === people?.userid,
                  );
                  return (
                    <div
                      key={index}
                      className={`peoples-flex ulterDrop w-100 m-0 ${
                        isUserAssigned
                          ? "selectedAssignee"
                          : "non-selectedAssignee"
                      }`}
                      onClick={() => {
                        if (
                          record?.assignedTo?.some(
                            (x) => x?.userId === people?.userid,
                          )
                        ) {
                          return; // if already assigned -> return from here.
                        }
                        dispatch(
                          assignMaintenence(record.assetMaintainaceId, {
                            userId: people.userid,
                            imageurl: people.imageurl,
                            firstname: people.firstname,
                            lastname: people.lastname,
                          }),
                        );
                        setShowDropPeople(false);
                        // setChangeComp(people.userid);

                        // setSelectedAssignee([
                        //   ...selectedAssignee,
                        //   people.userid,
                        // ]);
                      }}
                    >
                      {people.imageurl ? (
                        <img
                          alt=""
                          src={people.imageurl}
                          style={{
                            width: "clamp(21px, 2vw, 2vw)",
                            height: "clamp(21px, 2vw, 2vw)",
                            borderRadius: "100%",
                            border: "2px solid var(--unnamed-color-00246a)",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            backgroundColor: "#95A7C6",
                            color: "#ffffff",
                            width: "clamp(21px, 2vw, 2vw)",
                            height: "clamp(21px, 2vw, 2vw)",
                            borderRadius: "100%",
                            border: "2px solid var(--unnamed-color-00246a)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {people?.lastname
                            ? people?.firstname[0]?.toUpperCase() +
                              "" +
                              people?.lastname[0]?.toUpperCase()
                            : people?.firstname?.slice(0, 2).toUpperCase()}
                        </div>
                      )}

                      <p
                        style={{
                          marginBottom: "0",
                          textAlign: "start",
                          gap: "8px",
                        }}
                        className="assign-user"
                      >
                        {people?.firstname} {people?.lastname}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/*////// ASC WITH IMG SELECT BOX END //////*/}
        </div>
      ),
    },
    {
      // title: "Status",
      title: t("Status"),
      dataIndex: "status",
      key: "status",
      width: "20%",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: sortBy(statusList, ["order"]).map((s, i) => ({
                key: i,
                label: s.statusName,
              })),
              onClick: (e) => {
                if (
                  items[e.key].statusName !== "Pending" &&
                  record.assignedTo.length === 0
                ) {
                  alert("please assign assignee to maintenance");
                } else {
                  dispatch(
                    changeMaintenanceStatus(
                      record.assetMaintainaceId,
                      items[e.key].statusId,
                    ),
                  );
                }
              },
            }}
          >
            <span className="px-2 w-100 d-flex">
              <span style={{ width: "120px", display: "block" }}>
                {record.status ? record.status.statusName : "Pending"}
              </span>
              <DownOutlined className="" />
            </span>
          </Dropdown>
        </Space>
      ),
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <img
            src={Kebab}
            alt="menu icon"
            className="quote-menu-icon inside-menu"
            style={{
              transform:
                record.assetMaintainaceId === activeMenu &&
                menuActive &&
                "rotate(-90deg)",
              // opacity: status === "Deactivated" ? "0.6" : "1",
            }}
            onClick={() => {
              if (menuActive === true) return setMenuActive(false);
              setMenuActive(true);
              setActiveMenu(record.assetMaintainaceId);
              console.log("asc 3dot pop", record);
              setAssetMaintenanceId(record.assetMaintainaceId);
            }}
          />
          <section
            className="quote-menu quote-menu-2"
            style={{
              transform:
                record.assetMaintainaceId === activeMenu && menuActive
                  ? "scale(1)"
                  : "scale(0)",
              transitionDuration: "300ms",
              top: "0",
            }}
          >
            <div className="menu-icon-cont">
              <img
                src={Kebab}
                alt="menu icon"
                className="quote-menu-icon inside-menu"
                style={{
                  transform: "rotate(-90deg)",
                }}
                onClick={() => {
                  if (menuActive === true) return setMenuActive(false);
                  setMenuActive(true);
                }}
              />
            </div>
            <div className="quote-menu-list fc">
              <section
                className="fr menu-single-item"
                style={{
                  gap: "10px",
                  alignItems: "center",
                }}
                onClick={() => !showModal && setShowModal(true)}
              >
                <img
                  src={Reload}
                  alt="Menu Icons"
                  style={{
                    width: "21px",
                    height: "21px",
                  }}
                />
                <span>Create Recurrence</span>
                {showModal && (
                  <RecurrenceModal
                    setMenuActive={setMenuActive}
                    record={record}
                    showModal={showModal}
                    setShowModal={setShowModal}
                  />
                )}
              </section>
              <section
                className="fr menu-single-item"
                style={{
                  gap: "10px",
                }}
                onClick={() => history.push("/view-purchasing-order-assets")}
              >
                <img src={invoice} alt="Menu Icons" />
                <span>Create PO</span>
              </section>
              <section
                className="fr menu-single-item"
                style={{
                  gap: "10px",
                }}
                onClick={() => {
                  // setShowDelete(true);
                  // setMenuActive(false);
                }}
              >
                <img src={delete1} alt="Menu Icons" />
                <span
                  onClick={() => {
                    setShowDelete(true);
                  }}
                >
                  Delete
                </span>
                {showDelete && (
                  <DeletePopUp
                    animation={true}
                    handleDelete={() => {
                      setShowDelete(!showDelete);
                      setMenuActive(false);
                      dispatch(deleteMaintenance(assetMaintainaceId));
                    }}
                    show={showDelete}
                    onHide={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setShowDelete(false);
                    }}
                    title1={"This data will be removed from the system"}
                    title2={"and cannot be undone."}
                    title3={"Do you want to proceed?"}
                    no={"No"}
                    yes={"Yes"}
                  />
                )}
              </section>
            </div>
          </section>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Table
        dataSource={maintenanceList || []}
        columns={columns}
        // bordered
        pagination={false}
        rowClassName={(record) =>
          record?.status && record.status.statusName === "Complete"
            ? "bg-complete tableRowRoundedBorder"
            : "tableRowRoundedBorder"
        }
      />
    </div>
  );
};
